export default "__VITE_ASSET__DuMFEu2Z__"